import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/images/logo/alba.png'


const _hoisted_1 = { class: "backSileAppUpdate" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-5",
  style: {"margin-top":"20px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold px-0 mx-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "friColor1" }, "Actualización"),
  /*#__PURE__*/_createTextVNode(" disponible")
], -1)
const _hoisted_4 = { class: "fs-5 px-0 mx-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mx-5 fs-6 px-5" }, "Esta actualización incluye mejoras en la interfaz de usuario y correcciones de errores.", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = ["href", "download"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "btn friBack1 btn-lg text-white px-5 py-3" }, "Descargar ahora", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "backSileAppInstall" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "p-5",
    style: {"margin-top":"20px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-left mx-5 fs-6 mt-1" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "fw-bold px-0 mx-0 mb-5",
      style: {"font-size":"25px","line-height":"30px"}
    }, "Cómo instalar en Android"),
    /*#__PURE__*/_createTextVNode(" Para ello, debemos habilitar en nuestro dispositivo la posibilidad de descargar programas desde lugares externos a la tienda de aplicaciones de Google. "),
    /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
      /*#__PURE__*/_createTextVNode(" Para permitir la instalación de aplicaciones en formato APK desde nuestro teléfono Android tan sólo deberemos dirigirnos a: "),
      /*#__PURE__*/_createElementVNode("strong", null, "Menú > Ajustes > Seguridad"),
      /*#__PURE__*/_createTextVNode(" y marcar la casilla "),
      /*#__PURE__*/_createElementVNode("strong", null, "‘Orígenes Desconocidos’ o ‘Fuentes Desconocidas’"),
      /*#__PURE__*/_createTextVNode(", así de sencillo. ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      (_ctx.layout.isMobile && _ctx.profile && _ctx.layout.packageJsonVersion && _ctx.layout.lastFile && _ctx.layout.packageJsonVersion!=_ctx.layout.lastFile)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            fullscreen: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_slides, { class: "px-0 mx-0 h-100" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_slide, { class: "px-0 mx-0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, "Nueva versión " + _toDisplayString(_ctx.layout.lastFile), 1),
                        _hoisted_5,
                        (_ctx.layout.apkStoragePath)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("a", {
                                  href: _ctx.layout.apkStoragePath,
                                  download: _ctx.layout.lastFile
                                }, _hoisted_10, 8, _hoisted_8)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_slide, { class: "px-0 mx-0" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_router_outlet, {
            key: 1,
            class: "inner-scroll"
          }))
    ]),
    _: 1
  }))
}